import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Switch, Tag , Select, InputNumber } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, DeleteOutlined, MobileOutlined } from '@ant-design/icons';

import { ASSIGN_USERS_LIST, ASSIGN_USERS_LIST_SUCCESS, ASSIGN_USERS_LIST_ERROR, DELETE_HANDSET_LIST_ERROR, DELETE_HANDSET_LIST_SUCCESS, DELETE_HANDSET_LIST, UPDATE_HANDSET_LIST_ERROR, UPDATE_HANDSET_LIST_SUCCESS, UPDATE_HANDSET_LIST, ADD_HANDSET_LIST_DETAILS_ERROR, ADD_HANDSET_LIST_DETAILS_SUCCESS, ADD_HANDSET_LIST_DETAILS, HANDSET_LIST_DETAILS_ERROR, HANDSET_LIST_DETAILS_SUCCESS, HANDSET_LIST_DETAILS, HANDSET_LIST_ERROR, HANDSET_LIST_SUCCESS, HANDSET_LIST } from './constants';

import handsetstatusReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { InfoOutlined} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function Handsetreport() {

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {handsetstatus : [], users : [] , details: null, pending: false, error: false };
	const [data, dispatch] = useReducer(handsetstatusReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showAddHandsetStatusModal, setShowAddHandsetStatusModal] = useState(false);
	const [showEditHandsetStatusModal, setShowEditHandsetStatusModal] = useState(false);
	const [showDeleteHandsetStatusModal, setShowDeleteHandsetStatusModal] = useState(false);
	const [getUserAllocationData, setgetUserAllocationData] = useState(null);
	useAuth();
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const envExtendTimeout = process.env.REACT_APP_EXTEND_TIMEOUT == undefined || process.env.REACT_APP_EXTEND_TIMEOUT == 'undefined' ? 180000 : process.env.REACT_APP_EXTEND_TIMEOUT;
	const extendTimeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_EXTEND_TIMEOUT`) == 'null' ? parseInt(envExtendTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_EXTEND_TIMEOUT`));
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const navigate = useNavigate();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title:langdata&&langdata.simNumber?langdata.simNumber:'Sim Number',
			dataIndex: 'simNumber',
			key: 'simNumber',
			render:(_,record)=>{
				return record.simNumber ? record.simNumber : 'No Data';
			}
			
				
		},
		{
			title:langdata&&langdata.AssignedUser?langdata.AssignedUser:'Assigned User',
			dataIndex: 'assignedUser',
			key: 'assignedUser',
			
		},
		{
			title:langdata&&langdata.Allocation?langdata.Allocation:'Allocation',
			dataIndex: 'allocation',
			key: 'allocation',
			render:(_,record)=>{
				return record.allocation ? record.allocation : 'No Data';
			}
			
			
		},
		{
			title:langdata&&langdata.batteryPercentage?langdata.batteryPercentage:'Battery Percentage',
			dataIndex: 'batteryPercentage',
			key: 'batteryPercentage',
			
		},
		{
			title:langdata&&langdata.gsmStrength?langdata.gsmStrength:'GSM Strength',
			dataIndex: 'gsmStrength',
			key: 'gsmStrength',
			render:(_,record)=>{
				return record.gsmStrength ? record.gsmStrength : 'No Data';
			}
			
		},
		{
			title:langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number',
			dataIndex: 'imeiNumber',
			key: 'imeiNumber',
			render:(_,record)=>{
				return record.imeiNumber ? record.imeiNumber : 'No Data';
			}
			
		},
		{
			title: langdata&&langdata.Status?langdata.Status:'Status',
			dataIndex: 'status',
			key: 'status',
			render: (_,  status ) => (
				
				<>
					{status &&
						<Tag color={status.status === 'Active' ? 'green' :
							'red'}>
							{status.status === 'Active' ? (langdata && langdata.Active ? langdata.Active : 'Active') : (langdata && langdata.Inactive ? langdata.Inactive : 'Inactive')}
						</Tag>}
				</>
			),
			
		},

		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				permission === 'superadmin' || permission === 'admin' ? (
					<Space size="middle">
						<a title={langdata&&langdata.EditHandsetManagement?langdata.EditHandsetManagement:'Edit Handeset Management'} onClick={()=>openEdithandsetStatusModal(record)}><EditOutlined/></a>
						<a title={langdata&&langdata.DeleteHandsetManagement?langdata.DeleteHandsetManagement:'Delete Handset Management'} onClick={()=>openDeleteHandsetStatusModal(record)}><DeleteOutlined /></a>
					</Space>
				) : 
					(
						<Space size="middle">
							<a title={langdata&&langdata.EditVehicleManagement?langdata.EditVehicleManagement:'Edit vehicle Management'} onClick={()=>openEdithandsetStatusModal(record)}><EditOutlined/></a>
						</Space>
					)
			)
		}
	];

	const openAddHandsetStatusModal = () => {
		setShowAddHandsetStatusModal(true);
	};

	const cloaseAddHandsetStatusModal = () => {
		setShowAddHandsetStatusModal(false);
		setgetUserAllocationData(null);
		addHandsetStatusFormik.resetForm();
	};

	const openEdithandsetStatusModal = (record) => {
		setShowEditHandsetStatusModal(true);
		getUserallocation(record?.assignedUserId);
		loadhandsetStatusDetails(record);
	};

	const closeEditHandsetStatusModal = () => {
		setShowEditHandsetStatusModal(false);
		setgetUserAllocationData(null);
		updateHandsetStatusFormik.resetForm();
	};

	const openDeleteHandsetStatusModal = (record) => {
		setShowDeleteHandsetStatusModal(true);
		loadhandsetStatusDetails(record);

	};

	//Permission functions 
	

	const loadAssignUser = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/users?&usertypeId[$in][]=4&usertypeId[$in][]=5&usertypeId[$in][]=7&usertypeId[$in][]=13`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {

				if (response.status === 200) {
					dispatch({type:ASSIGN_USERS_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:ASSIGN_USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};



	const deletehandsetStatus = () => {
		const id = data?.details?.id;
    
		dispatch({ type: DELETE_HANDSET_LIST });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/handsetmanagement/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_HANDSET_LIST_SUCCESS, payload: response});
					setShowDeleteHandsetStatusModal(false);   
					loadHandesetStatus();       
				} else {
					dispatch({type:DELETE_HANDSET_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_HANDSET_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeleteHandsetStatusModal = () => {
		setShowDeleteHandsetStatusModal(false);
	};

	useEffect(() => {
		if(featuresModule.handsetManagementEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4033);
	}, []);

	useEffect(() => {
		dispatch( { type: HANDSET_LIST });
      
		loadHandesetStatus();
	}, []);


	useEffect(() => {
		dispatch( { type: ASSIGN_USERS_LIST });
      
		loadAssignUser();
	}, []);


	const loadHandesetStatus = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/handsetmanagement-list?&pipelineId=${parseInt(pipelineId)}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:HANDSET_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:HANDSET_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadhandsetStatusDetails = ((record) => {


		dispatch( { type: HANDSET_LIST_DETAILS });
    
		if (!record) {
			dispatch({ type: HANDSET_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: HANDSET_LIST_DETAILS_SUCCESS, payload: record });

		}

	});

	

	const addHandsetStatusFormik = useFormik({
		initialValues: {
			name : '',
			assignedUserId : 0,
			status : 'Active',
			batteryPercentage : 0,
			imeiNumber : '',
			allocationId : null,
			gsmStrength:null,
			simNumber: ''

		},
		onSubmit: (values) => {

			const name = values.name ? values.name : '';
			const assignedUserId = values.assignedUserId ? values.assignedUserId : 0;
			const status = values.status ? 'Active' : 'Inactive';
			const batteryPercentage = values.batteryPercentage ? values.batteryPercentage : 0;
			const imeiNumber = values.imeiNumber ? values.imeiNumber : '';
			const allocationId = values.allocationId ? values.allocationId : null;
			const simNumber = values.simNumber ? values.simNumber : '' ;
			const gsmStrength = values.gsmStrength ? Number(values.gsmStrength) : 0;

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}
			if (!assignedUserId || assignedUserId == null || assignedUserId === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' });
				return false;
			}
			
			if (!simNumber || simNumber == null || simNumber === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterSimNumber?langdata.PleaseEnterSimNumber:'Please enter Sim number' });
				return false;
			}

			
			


			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/handsetmanagement`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					assignedUserId :assignedUserId,
					batteryPercentage : Number(batteryPercentage),
					allocationId : allocationId ,
					status : status ,
					pipelineId : parseInt( pipelineId ),
					imeiNumber : imeiNumber,
					simNumber: simNumber,
					gsmStrength: gsmStrength

				}
			};

			dispatch( { type: ADD_HANDSET_LIST_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_HANDSET_LIST_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.HandsetManagementAddedSuccessfully ? langdata.HandsetManagementAddedSuccessfully : 'Handset management added successfully' });
						setShowAddHandsetStatusModal(false);
						addHandsetStatusFormik.resetForm();
						loadHandesetStatus();
					} else {
						dispatch({type: ADD_HANDSET_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToSaveHandsetManagement ? langdata.UnableToSaveHandsetManagement : 'Unable to save Handset management' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_HANDSET_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});



	const updateHandsetStatusFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			
								
			name : data.details && data.details.name ? data.details.name : '',
			assignedUserId : data.details &&  data.details.assignedUserId ? data.details.assignedUserId : 0,
			status :  data.details && data.details.status ? data.details.status === 'Active' ? true : false :  '',
			batteryPercentage : data.details && data.details.batteryPercentage ? data.details.batteryPercentage : 0,
			imeiNumber : data.details && data.details.imeiNumber ? data.details.imeiNumber : '',
			allocationId : data.details && data.details.allocationId ? data.details.allocationId : null,
			gsmStrength: data.details && data.details.gsmStrength ? data.details.gsmStrength : null,
			simNumber :  data.details &&  data.details.simNumber ? data.details.simNumber : '',

		},
		onSubmit: (values) => {
			const id = data.details.id;
			const name = values.name ? values.name : '';
			const assignedUserId = values.assignedUserId ? values.assignedUserId : 0;
			const status = values.status ?  'Active' : 'Inactive';
			const batteryPercentage = values.batteryPercentage ? values.batteryPercentage : 0;
			const imeiNumber = values.imeiNumber ? values.imeiNumber : '';
			const allocationId = values.allocationId ? values.allocationId : null;
			const simNumber = values.simNumber ? values.simNumber : '' ;
			const gsmStrength = values.gsmStrength ? Number(values.gsmStrength) : 0;


			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}
			if (!assignedUserId || assignedUserId == null || assignedUserId === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' });
				return false;
			}
			
			if (!simNumber || simNumber == null || simNumber === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterSimNumber?langdata.PleaseEnterSimNumber:'Please enter Sim number' });
				return false;
			}

			
			

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/handsetmanagement/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					assignedUserId : assignedUserId ,
					allocationId : allocationId ,
					status : status ,
					pipelineId : parseInt( pipelineId ),
					batteryPercentage : batteryPercentage,
					imeiNumber : imeiNumber,
					simNumber: simNumber,
					gsmStrength: gsmStrength

					

				}
			};

			dispatch( { type: UPDATE_HANDSET_LIST });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_HANDSET_LIST_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.HandsetManagementUpdatedSuccessfully ? langdata.HandsetManagementUpdatedSuccessfully : 'Handset management updated successfully' });
						setShowEditHandsetStatusModal(false);
						updateHandsetStatusFormik.resetForm();
						loadHandesetStatus();
					} else {
						dispatch({type: UPDATE_HANDSET_LIST_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToUpdatehandsetManagement ? langdata.UnableToUpdatehandsetManagement : 'Unable to update handset management' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_HANDSET_LIST_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.handsetmanagementinfocontent ? langdata.handsetmanagementinfocontent  :  'Handset Management is a module used to manage users of the STS mobile application. It provides an overview of registered devices along with their configurations.'}</p>
		</Card>
	);


	const assigneduserHandler = (value) => {
		addHandsetStatusFormik.setFieldValue('assignedUserId', value);
		addHandsetStatusFormik.setFieldValue('allocationId', null);
		setgetUserAllocationData(null);
		getUserallocation(value);
	};

	const updatehandsetassigneduserhandler = (value) => {
		updateHandsetStatusFormik.setFieldValue('assignedUserId', value);
		updateHandsetStatusFormik.setFieldValue('allocationId', null);
		setgetUserAllocationData(null);
		getUserallocation(value);

	};

	const getUserallocation = (id) =>{

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation?userId=${id}`,
			timeout: extendTimeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`   
			}
		};

		axios.request(config)
			.then((response) => {
				if ( response.status === 200) {
					setgetUserAllocationData(response.data.data);
				} else {
					console.log('Unable to fetch user allocation data');
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	
	};


	let regions = [];

	if(getUserAllocationData){
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
			});
		});
	}

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());



	return (
	// permission==='superadmin' || permission === 'admin' ? 

		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
						
				}}
				>

					<Col span={12}>
						<Row>
							<Space>
								<MobileOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata&&langdata.HandsetManagement?langdata.HandsetManagement:'Handset Management'}</Title>
						</Row>
					</Col>
					
					<Col span={12}>
						<Row justify="end">
							<Col>
								<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
									<Space>
										{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={openAddHandsetStatusModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
										{/* {<Button type="primary" onClick={openAddVehicleStatusModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button>} */}
									</Space>
								</Tooltip>
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata&&langdata.HandsetManagement?langdata.HandsetManagement:'Handset Management' }  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.handsetstatus.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data && data.handsetstatus} 
							/>
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.pending} />
      
			{/* Add Vehicle management Starts */}
			<Modal
				title={ langdata&&langdata.AddHandsetManagement?langdata.AddHandsetManagement:'Add Handset Management' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showAddHandsetStatusModal}
				onOk={{cloaseAddHandsetStatusModal}}
				onCancel={cloaseAddHandsetStatusModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={cloaseAddHandsetStatusModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addHandsetStatusFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical"  onSubmit={addHandsetStatusFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="name" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} >
								<Input name="name" onChange={addHandsetStatusFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="assignedUserId" label={ langdata&&langdata.AssignedUser?langdata.AssignedUser:'Assigned user'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' }]} >
								<Select name="assignedUserId" onChange={(value) => assigneduserHandler(value)} placeholder={ langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user'} 
									showSearch
									optionFilterProp="children"
									filterOption={filterOption}
									options={data.users} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={ langdata&&langdata.Allocation?langdata.Allocation:'Allocation'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' }]} >
								<Select name="allocationId"
									showSearch 
									disabled={getUserAllocationData && getUserAllocationData.length === 0 || getUserAllocationData === null} onChange={(value) => addHandsetStatusFormik.setFieldValue('allocationId', value)} placeholder={getUserAllocationData === null ? langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : getUserAllocationData && getUserAllocationData.length > 0 ?  langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : langdata&&langdata.Thereisnoallocationforthisuser?langdata.Thereisnoallocationforthisuser:'There is no allocation for this user'} 
									options={regions}
									optionFilterProp="children"
									filterOption={filterOption}
									value={addHandsetStatusFormik.values.allocationId} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="batteryPercentage" label={langdata&&langdata.batteryPercentage?langdata.batteryPercentage:'Battery Percentage'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterBatteryPercentage?langdata.PleaseEnterBatteryPercentage:'Please enter battery percentage' }]} > 
								<InputNumber name="batteryPercentage" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addHandsetStatusFormik.setFieldValue('batteryPercentage', value)} 
									placeholder={langdata&&langdata.PleaseEnterBatteryPercentage?langdata.PleaseEnterBatteryPercentage:'Please enter battery percentage'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="imeiNumber" label={langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterIMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number' }]} >
								<Input name="imeiNumber" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									
									onChange={addHandsetStatusFormik.handleChange}
									placeholder={langdata&&langdata.PleaseEnterIMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="simNumber" label={langdata&&langdata.simNumber ?langdata.simNumber:'Sim Number'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterSimNumber?langdata.PleaseEnterSimNumber:'Please enter Sim number'}]} >
								<Input name="simNumber" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									
									onChange={addHandsetStatusFormik.handleChange}
									placeholder={langdata&&langdata.PleaseEnterSimNumber?langdata.PleaseEnterSimNumber:'Please enter Sim number'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="gsmStrength" label={langdata&&langdata.gsmStrength?langdata.gsmStrength:'GSM Strength'} rules={[{ required: false, message: langdata&&langdata.PleaseentergsmStrength?langdata.PleaseentergsmStrength:'Please enter GSM Strength'}]} >
								<InputNumber name="gsmStrength" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addHandsetStatusFormik.setFieldValue('gsmStrength', value)} 
									placeholder={langdata&&langdata.PleaseentergsmStrength?langdata.PleaseentergsmStrength:'Please enter GSM Strength'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="status" label={ langdata&&langdata.Status?langdata.Status:'Status'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterStatus?langdata.PleaseEnterStatus:'Please enter status' }]} >
								<Switch checkedChildren = {langdata && langdata.Active ? langdata.Active : 'Active'} unCheckedChildren = {langdata && langdata.Inactive ? langdata.Inactive : 'Inactive'}
									onChange={(value) => addHandsetStatusFormik.setFieldValue('addVehiclestatusStatus', value)} 
									defaultChecked
									name="status"
									placeholder={ langdata&&langdata.PleaseEnterStatus?langdata.PleaseEnterStatus:'Please enter status'} />
							</Form.Item>
						</Col>
					</Row>
                                            
				</Form>
			</Modal>
			{/* Add Vehicle management Ends */}

			{/* Edit Vehicle management Starts */}
			<Modal
				
				title={ langdata&&langdata.EditHandsetManagement?langdata.EditHandsetManagement:'Edit Handset Management'}
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showEditHandsetStatusModal}
				onOk={{closeEditHandsetStatusModal}}
				onCancel={closeEditHandsetStatusModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeEditHandsetStatusModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						<Button type="primary" onClick={updateHandsetStatusFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> 
					</Space>
				]}
				width={800}
			>

				<Form layout="vertical" onSubmit={updateHandsetStatusFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
								<Input name="name" onChange={updateHandsetStatusFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} 
									value={updateHandsetStatusFormik.values.name} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="assignedUserId" label={ langdata&&langdata.AssignedUser?langdata.AssignedUser:'Assigned user'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' }]} >
								<Select name="assignedUserId" onChange={(value) => updatehandsetassigneduserhandler(value)} 
									placeholder={ langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user'} 
									options={data.users}
									showSearch
									optionFilterProp="children"
									filterOption={filterOption}
									defaultValue={data.details && data.details.assignedUser} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={ langdata&&langdata.Allocation?langdata.Allocation:'Allocation'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' }]} >
								<Select name="allocationId" 
									disabled={getUserAllocationData && getUserAllocationData.length === 0 || getUserAllocationData === null} onChange={(value) => updateHandsetStatusFormik.setFieldValue('allocationId', value)} placeholder={getUserAllocationData === null ? langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : getUserAllocationData && getUserAllocationData.length > 0 ?  langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : langdata&&langdata.Thereisnoallocationforthisuser?langdata.Thereisnoallocationforthisuser:'There is no allocation for this user'} 
									options={regions}
									showSearch
									optionFilterProp="children"
									filterOption={filterOption}
									value={updateHandsetStatusFormik.values.allocationId}
									defaultValue={updateHandsetStatusFormik.values.allocationId} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="batteryPercentage" label={langdata&&langdata.batteryPercentage?langdata.batteryPercentage:'Battery Percentage'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterBatteryPercentage?langdata.PleaseEnterBatteryPercentage:'Please enter battery percentage' }]} >
								<InputNumber name="batteryPercentage" 
									style={
										{
											width : '100%'
										}
									}
								
									min={0}
									step={0.1}
									onChange={(value) => updateHandsetStatusFormik.setFieldValue('batteryPercentage', value)} 
									placeholder={langdata&&langdata.PleaseEnterBatteryPercentage?langdata.PleaseEnterBatteryPercentage:'Please enter battery percentage'} 
									defaultValue ={updateHandsetStatusFormik.values.batteryPercentage}/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="imeiNumber" label={langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterIMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number' }]} >
								<Input name="imeiNumber" 
									style={
										{
											width : '100%'
										}
									}
									onChange={updateHandsetStatusFormik.handleChange} 
									placeholder={langdata&&langdata.IMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number'} 
									defaultValue ={updateHandsetStatusFormik.values.imeiNumber}/>
							</Form.Item>
						</Col>
					</Row>
				
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="simNumber" label={langdata&&langdata.simNumber ?langdata.simNumber:'Sim Number'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterSimNumber?langdata.PleaseEnterSimNumber:'Please enter Sim number'}]} >
								<Input name="simNumber" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									defaultValue={updateHandsetStatusFormik.values.simNumber}
									
									onChange={updateHandsetStatusFormik.handleChange}
									placeholder={langdata&&langdata.PleaseEnterSimNumber?langdata.PleaseEnterSimNumber:'Please enter Sim number'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="gsmStrength" label={langdata&&langdata.gsmStrength?langdata.gsmStrength:'GSM Strength'} rules={[{ required: false, message: langdata&&langdata.PleaseentergsmStrength?langdata.PleaseentergsmStrength:'Please enter GSM Strength'}]} >
								<InputNumber name="gsmStrength" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									defaultValue={updateHandsetStatusFormik.values.gsmStrength}
									onChange={(value) => updateHandsetStatusFormik.setFieldValue('gsmStrength', value)} 
									placeholder={langdata&&langdata.PleaseentergsmStrength?langdata.PleaseentergsmStrength:'Please enter GSM Strength'} />
							</Form.Item>
						</Col>
					</Row> 

					<Row gutter={24}>
						
						<Col span={24}>
							<Form.Item label={langdata&&langdata.Status?langdata.Status:'Status'} rules={[{ required: false, message: langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name' }]} >
								<Switch name="status"
									
									onChange={(value) => updateHandsetStatusFormik.setFieldValue('status', value)} 
									checked = {updateHandsetStatusFormik.values.status}
									checkedChildren = {langdata && langdata.Active ? langdata.Active : 'Active'} unCheckedChildren = {langdata && langdata.Inactive ? langdata.Inactive : 'Inactive'}  value={updateHandsetStatusFormik.values.updateSpeedClassificationActivityName} />
							</Form.Item>
						</Col>
					</Row>
                        
                        

                        
				</Form>
			</Modal>
			{/* Edit Vehicle management Ends */}

			{/* Delete  Vehicle management Starts */}
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteHandsetStatusModal} onOk={deletehandsetStatus} onCancel={closeDeleteHandsetStatusModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.ConfirmDeleteHandsetManagement?langdata.ConfirmDeleteHandsetManagement:'Are you sure you want to delete this Handset Management?' }</Col>
				</Row>
			</Modal>
			{/* Delete  Vehicle management Ends */}
		</> 
	);
}